import { INewFolder } from '@commenda/types/src/drive-view/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useGetDriveView(
  corporationId: number | null,
  viewType?: string
) {
  let url = 'drive-view/view';
  const query = new URLSearchParams();
  query.append('corporationId', corporationId?.toString());

  if (viewType?.length) query.append('viewType', viewType?.toString());

  if (query.toString() !== '') {
    url += `?${query.toString()}`;
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: { folder: INewFolder };
    error?: unknown;
    mutate: KeyedMutator<{ folder: INewFolder }>;
  } = useSWR(
    corporationId ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
